// extracted by mini-css-extract-plugin
export default {"canvasButton":"Sketch_canvasButton__DPScf","isSelected":"Sketch_isSelected__GJj+L"};